import { EnvironmentService } from 'shared/services';

type OAuthConfig = {
  domain: string;
  scope: string[];
  redirectSignIn: string;
  redirectSignOut: string;
  responseType: 'code';
};

type Pool = {
  userPoolId?: string;
  userPoolWebClientId?: string;
  oauth?: OAuthConfig;
};

const ogpOAuthDomain = EnvironmentService.getVariable('COGNITO_OGP_OAUTH_DOMAIN');
const ogpOAuthRedirectSignIn = EnvironmentService.getVariable('COGNITO_OGP_OAUTH_REDIRECT_SIGN_IN');
const ogpOAuthRedirectSignOut = EnvironmentService.getVariable(
  'COGNITO_OGP_OAUTH_REDIRECT_SIGN_OUT'
);

const ogpOAuth: OAuthConfig | undefined =
  ogpOAuthDomain && ogpOAuthRedirectSignIn && ogpOAuthRedirectSignOut
    ? {
        domain: ogpOAuthDomain,
        scope: ['email', 'openid', 'profile'],
        redirectSignIn: ogpOAuthRedirectSignIn,
        redirectSignOut: ogpOAuthRedirectSignOut,
        responseType: 'code',
      }
    : undefined;

const pools: Record<'ogp' | 'hq' | 'partner', Pool> = {
  ogp: {
    userPoolId: EnvironmentService.getVariable('COGNITO_OGP_USER_POOL_ID'),
    userPoolWebClientId: EnvironmentService.getVariable('COGNITO_OGP_USER_POOL_CLIENT_ID'),
    oauth: ogpOAuth,
  },
  hq: {
    userPoolId: EnvironmentService.getVariable('COGNITO_HQ_USER_POOL_ID'),
    userPoolWebClientId: EnvironmentService.getVariable('COGNITO_HQ_USER_POOL_CLIENT_ID'),
  },
  partner: {
    userPoolId: EnvironmentService.getVariable('COGNITO_PARTNER_USER_POOL_ID'),
    userPoolWebClientId: EnvironmentService.getVariable('COGNITO_PARTNER_USER_POOL_CLIENT_ID'),
  },
};

export { pools };
export type { Pool };
